exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cke-text-alternative-form{padding:1.2em;overflow:hidden}.cke-text-alternative-form:focus{outline:none}.cke-text-alternative-form .ck-label{margin-bottom:.4em}.cke-text-alternative-form__actions{clear:both;padding-top:1.2em}.cke-text-alternative-form__actions .ck-button{float:right}.cke-text-alternative-form__actions .ck-button+.ck-button{margin-right:.64em}.cke-text-alternative-form__actions .ck-button+.ck-button+.ck-button{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /workspace/ckeditor5/node_modules/css-loader?{"minimize":true}!/workspace/ckeditor5/node_modules/sass-loader/lib/loader.js!../ckeditor5-image/theme/imagetextalternative/theme.scss
// module id = 23
// module chunks = 0